import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start

import { IFilter } from "../../../components/src/FilterPopover";
import { ISortingData } from "../../../components/src/SortingTableHeader2";
import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey,
  navigateTo,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import moment from "moment";
import { isArray } from "lodash";

export const configJSON = require("./config");
export interface ISection {
  id: number;
  name: string;
  section_name: string;
  section_second_name: string;
}
export interface IPlatform {
  id: number;
  name: string;
}

export type DialogPayload = {
  selectedBusinessAccount?: StoreDiscountStatus;
  dialogTitle?: string;
  apiMessage?: string;
  action: "View" | "Renew" | "Activate" | "Deactivate" | "Done" | "Delete";
};
export interface IStoreDiscount {
  id: string;
  type: string;
  used_orders?: number;
  used_pieces?: number;
  sub_total?: string;
  revenue?: string;
  available_times: {
    id?: number;
    from: string;
    to: string;
  };
  attributes: {
    status: string;
    end_date: string;
    name: string;
    start_date: string;
    sections: Array<ISection>;
    platforms: Array<IPlatform>;
    store_managements: { id: number; store_name: string }[];
  };
}

export type StoreDiscountStatus = {
  id: string;
  used_orders?: number;
  used_pieces?: number;
  subtotal?: string;
  discount?: string;
  net_pay?: string;
  revenue?: string;
  // "subtotal": 480.44,
  //       "discount": 279.13,
  //       "revenue": 324.34,
  //       "net_pay": 324.34
  available_times: {
    id?: number;
    from: string;
    to: string;
  };
};

export const makeApiMessage = ({
  url = "",
  headers = {},
  method = "GET",
  body = null,
  isHeader = false,
}: {
  body?: any;
  url: string;
  headers?: any;
  method: string;
  isHeader?: boolean;
}) => {
  const requestMessage = new Message(
    getName(MessageEnum.RestAPIRequestMessage)
  );

  const header = {
    "Content-Type": "application/json",
    token: localStorage.getItem("token"),
    ...headers,
  };

  const headreWithoutContentType = {
    token: localStorage.getItem("token"),
    ...headers,
  };
  requestMessage.addData(
    getName(MessageEnum.RestAPIResponceEndPointMessage),
    url
  );
  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestHeaderMessage),
    JSON.stringify(!isHeader ? header : headreWithoutContentType)
  );
  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestMethodMessage),
    method
  );
  body &&
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      body
    );

  return requestMessage;
};
interface IFilterOmitValue extends Omit<IFilter, "value"> {
  value?: string | string[] | Date[] | [null, null] | [undefined, undefined];
}
export interface IFilterItem extends Omit<IFilterOmitValue, "apiKey"> {
  apiKey?: string | string[];
}

const Strings = configJSON.Strings.storeDiscountList;
const ApiUrls = configJSON.ApiUrls;
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  filters: IFilterItem[];
  sortingData: ISortingData;
  filterAnchor: { currentTarget: {} } | undefined | HTMLDivElement;
  totalCount: number;
  popOverTop: number;
  popOverLeft: number;
  endDate: Date | null | string | undefined;
  startDate: Date | null | string | undefined;
  popOverOpened: boolean;
  confirmModalFlag: boolean;
  confirmModalType: boolean;
  sectionList: Array<ISection>;
  sectionSelected: Array<string>;
  storeDiscountList: Array<IStoreDiscount>;
  permissionStatus: PermissionStatus;
  isLoadingPermission: boolean;
  isAppliedFilter: boolean;
  isLoading: boolean;
  openStoreListDialog: boolean;
  listingDataShow: string[];
  dialogPayload: DialogPayload | null;
  isLoadingDialog: boolean;
  // Customizable Area End
}

export interface SS {}

class StoreDiscountListController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  filterQuery: string = "";
  searchQuery: string = "";
  currentPage: number = 1;
  rowPerPage: number = 10;
  sortQuery: string = "";

  promoSortingId: string = "";
  sectionMessageId: string = "";
  confirmModalValue: string = "";
  popOverItemStatus: string = "";
  deactivateMessageId: string = "";
  getUsedOrdersPiecesCallId: string = "";
  popOverItemId: string | number = "";

  sortingProps = {
    width: "18%",
    onQueryChange: (query: string) => {
      this.sortQuery = query;
      this.getPromoCodesApi();
    },
    onChange: (d: ISortingData) => this.setState({ sortingData: d }),
  };
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.SearchTextMessage),
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.extractDataFromLayout(message);
    this.gatherSearchTextData(message);
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (requestId === this.sectionMessageId) {
      this.setState({
        sectionList:
          successResponse.data.map(
            (item: { attributes: {} }) => item.attributes
          ) || [],
      });

      const seactionResults = successResponse.data?.map(
        (item: { id: number; attributes: { section_name: string } }) => {
          return {
            value: String(item.id),
            label: item.attributes.section_name,
          };
        }
      );
      const existingFilter = this.state.filters.find(
        (item) => item.title === "Section"
      );
      if (!existingFilter) return;
      existingFilter.options = seactionResults;
      this.setState({ filters: [...this.state.filters] });
    } else if (requestId === this.promoSortingId) {
      const { total_count, current_page } = successResponse.meta || {};

      this.currentPage = current_page || 1;
      this.setState({ totalCount: total_count || 1, isLoading: false });

      this.setState({ storeDiscountList: successResponse.data });
    } else if (requestId === this.deactivateMessageId) {
      if (successResponse) {
        this.setState({
          confirmModalFlag: this.popOverItemStatus === "active",
        });
        this.setState({ popOverOpened: false });
        this.getPromoCodesApi();
      }
    } else if (requestId === this.getUsedOrdersPiecesCallId) {
      const { data: ordersData = {} } = successResponse;
      const { used_orders, used_pieces, discount, net_pay, revenue, subtotal } =
        ordersData;
      if (this.state.dialogPayload?.selectedBusinessAccount) {
        this.setState({
          dialogPayload: {
            ...this.state.dialogPayload,
            selectedBusinessAccount: {
              ...this.state.dialogPayload.selectedBusinessAccount,
              used_orders,
              used_pieces,
              discount,
              net_pay,
              revenue,
              subtotal,
            },
          },
          isLoadingDialog: false,
        });
      }
      if (successResponse) {
        this.setState({
          confirmModalFlag: this.popOverItemStatus === "active",
        });
        this.setState({ popOverOpened: false });
        this.getPromoCodesApi();
      }
    }
  }

  async componentDidMount() {
    super.componentDidMount();
    this.handleStorageFilter();
  }

  extractDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if (recievedData.userContext) {
        this.handleUserChange(recievedData.userContext);
      }
    }
  };

  gatherSearchTextData = (message: Message) => {
    if (message.id === getName(MessageEnum.SearchTextMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.SearchMessageText)
      );
      if (recievedData) {
        this.searchQuery = !recievedData.searchText
          ? ""
          : "&filter_by[query]=" + recievedData.searchText;
        this.currentPage = 1;
        this.getPromoCodesApi();
      }
    }
  };

  getPromoCodesApi() {
    this.setState({ isLoading: true });
    let paginationQuery = `page_no=${this.currentPage}&per_page=${this.rowPerPage}`;
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: window.localStorage.getItem("token"),
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      ApiUrls.listApi +
        paginationQuery +
        this.filterQuery +
        this.searchQuery +
        this.sortQuery
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");

    this.promoSortingId = getDataMsg.messageId;
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  }

  onChangePage(page: number) {
    this.currentPage = page;
    this.getPromoCodesApi();
  }

  getSectionList() {
    let requestMessage: Message = MakeApiMessage({
      url: ApiUrls.sectionList + localStorage.getItem(configJSON.Strings.token),
      method: "GET",
    });
    this.sectionMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  checkIsFilterApplied = (filters: IFilterItem[]) => {
    let value = false;
    filters.forEach((filter) => {
      if (value) {
        return;
      } else {
        if (isArray(filter.value)) {
          if (filter.value[0] || filter.value[1]) {
            value = true;
          }
        } else {
          if (filter.value) {
            value = true;
          }
        }
      }
    });
    return value;
  };

  onApplyFilter(filters: IFilterItem[]) {
    // set filter applied value set
    if (this.checkIsFilterApplied(filters)) {
      localStorage.setItem("promocode_filter_value", JSON.stringify(filters));
    } else {
      localStorage.removeItem("promocode_filter_value");
    }

    this.filterQuery = filters
      .map((currentFilter: IFilterItem) => {
        const { title, value, apiKey } = currentFilter;
        let apiString: string = "";

        if (title === "Date") {
          const [start, end] = value || [];
          start &&
            (apiString = `filter_by[start_date]=${moment(start).format(
              "DD-MM-YYYY"
            )}`);

          end &&
            (apiString += `&filter_by[end_date]=${moment(end).format(
              "DD-MM-YYYY"
            )}`);
        } else if (title === "Section") {
          if (value && value.length) {
            apiString = (value as string[]).reduce(
              (param: string, varc: string) =>
                param + "&filter_by[section_ids][]=" + varc,
              ""
            );
          }
        } else value && (apiString = `filter_by[${apiKey}]=${value}`);

        return apiString;
      })
      .filter((item) => item)
      .join("&");

    if (this.filterQuery) this.filterQuery = "&" + this.filterQuery;

    this.setState(
      {
        isAppliedFilter: this.checkIsFilterApplied(filters),
      },
      () => this.getPromoCodesApi()
    );
  }

  handleConfirmModal() {
    this.setState({
      confirmModalFlag: false,
    });

    setTimeout(() => {
      if (!this.state.confirmModalType) {
        this.setState({
          confirmModalType: true,
        });
        this.onEditApi();
      } else this.setState({ confirmModalType: false });
    }, 1000);
  }

  handleCloseStoreList = () => {
    this.setState({
      openStoreListDialog: false,
      listingDataShow: [],
    });
  };

  handleStoreList = (list: { id: number; store_name: string }[]) => {
    this.setState({
      openStoreListDialog: true,
      listingDataShow: list.map((item) => item.store_name),
    });
  };

  handleViewStatus = (store_discount: StoreDiscountStatus) => {
    this.setState({
      dialogPayload: {
        action: "View",
        selectedBusinessAccount: store_discount,
      },
      isLoadingDialog: true,
    });
    const apiMessage = makeApiMessage({
      url: `${ApiUrls.ordersData}?id=${store_discount.id}`,
      method: "get",
    });
    this.getUsedOrdersPiecesCallId = apiMessage.messageId;
    runEngine.sendMessage(apiMessage.id, apiMessage);
  };

  onEditApi(activate = false) {
    let requestMessage = MakeApiMessage({
      url: ApiUrls.editStoreDiscount + this.popOverItemId,
      method: "PUT",
      body: JSON.stringify({
        data: {
          status: activate ? "active" : "inactive",
        },
      }),
    });
    this.deactivateMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleFilterChange(event: { currentTarget: {} } | undefined) {
    this.setState({
      filterAnchor: event?.currentTarget as HTMLDivElement | undefined,
    });
    if (this.state.sectionList.length === 0) {
      this.getSectionList();
    }
  }

  handleUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.storeDiscountPermissions;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForNewPermissonStatus(
      apiKey,
      userData as Array<PermissionGroupArray>
    );
    this.setState({
      permissionStatus: value,
      isLoadingPermission: false,
    });
  };

  handleRedirection = (screen: string) => {
    navigateTo({
      props: this.props,
      screenName: screen,
    });
  };

  handleReturnColorType = () => {
    const { isAppliedFilter } = this.state;
    return isAppliedFilter ? "primary" : "inherit";
  };

  handleSetStateFilter = (filters: IFilterItem[]) => {
    this.setState({ filters });
  };

  handleStorageFilter = () => {
    const applied_area_filter = localStorage.getItem("promocode_filter_value");
    if (applied_area_filter) {
      this.setState(
        {
          filters: JSON.parse(applied_area_filter),
          isAppliedFilter: this.checkIsFilterApplied(
            JSON.parse(applied_area_filter)
          ),
        },
        () => this.onApplyFilter(this.state.filters)
      );
    } else {
      this.onApplyFilter(this.state.filters);
    }
  };

  handleToggleDialog = (dialogPayload?: DialogPayload) => {
    this.setState({ dialogPayload: dialogPayload || null });
  };
  // Customizable Area End
}

export default StoreDiscountListController;
